exports.ArrayOfArrayOfStringToArrayOfStringJsonTransformer = () => {
  return {
    convertToVersionOne: (setOfString) => {
      return setOfString.map(item => {
        let parsedItem = JSON.parse(item)
        let v1Item = []
        for (let key in parsedItem) {
          if (parsedItem.hasOwnProperty(key)) {
            v1Item.push(`${key}:${parsedItem[key]}`)
          }
        }
        return v1Item
      })
    },
    convertToVersionTwo: (setOfSetOfString) => {
      return setOfSetOfString.map(item => {
        let jsonNode = {}
        item.forEach(keyValueString => {
          let keyValue = keyValueString.split(/:(.*)/, 2)
          jsonNode[keyValue[0]] = keyValue[1] ? keyValue[1]: ''
        })
        return JSON.stringify(jsonNode)
      })
    }
  }
}

exports.ArrayOfStringToArrayOfStringJsonTransformer = (keysInOrder) => {
  return {
    convertToVersionOne: (setOfString) => {
      console.log(setOfString)
      return setOfString.map(item => {
        const jsonKeyValueMap = JSON.parse(item)
        let sortedKeyValueMap = {}
        Object.keys(jsonKeyValueMap).sort((a, b) => keysInOrder.indexOf(a) - keysInOrder.indexOf(b)).forEach(key => {
          sortedKeyValueMap[key] = jsonKeyValueMap[key]
        })
        return Object.values(sortedKeyValueMap).join('::')
      })
    },
    convertToVersionTwo: (setOfString) => {
      return setOfString.map(item => {
        let jsonNode = {}
        item.split('::').forEach((element, index) => {
          jsonNode[keysInOrder[index]] = element
        })
        return JSON.stringify(jsonNode)
      })
    }
  }
}

exports.ArrayOfStringToStringJsonTransformer = () => {
  return {
    convertToVersionOne: (string) => {
      let result = []
      let jsonStringToMap = JSON.parse(string)
      for (let key in jsonStringToMap) {
        if (jsonStringToMap.hasOwnProperty(key)) {
          result.push(`${key}:${jsonStringToMap[key]}`)
        }
      }
      return result
    },
    convertToVersionTwo: (setOfString) => {
      let jsonNode = {}
      setOfString.forEach(item => {
        let keyValue = item.split(/:(.*)/, 2)
        jsonNode[keyValue[0]] = keyValue[1]
      })

      return JSON.stringify(jsonNode)
    }
  }
}

exports.ArtworkUploadUrlMergeAndTransform = () => {
  const keysInOrder = ['artworkUploadId', 'artworkName', 'artworkUrl', 'artworkReviewer', 'uploadTimestamp']
  return {
    convertToVersionOne: (setOfString) => {
      let sortedInput = setOfString.sort((s1, s2) => {
        let s1Map = JSON.parse(s1)
        let s2Map = JSON.parse(s2)

        return new Date(s1Map['uploadTimestamp']) - new Date(s2Map['uploadTimestamp'])
      })

      const primaryFieldMap = JSON.parse(sortedInput[0])
      let sortedPrimaryFieldMap = {}
      Object.keys(primaryFieldMap).sort((a, b) => keysInOrder[a] - keysInOrder[b]).forEach(key => sortedPrimaryFieldMap[key] = primaryFieldMap[key])
      const primaryFieldData = Object.values(sortedPrimaryFieldMap).join("::")

      const secondaryFieldData = sortedInput.map((item, index) => {
        if (index === 0) return ""
        const secondaryFieldItemMap = JSON.parse(item)
        let sortedSecondaryFieldItemMap = {}
        Object.keys(secondaryFieldItemMap).sort((a, b) => keysInOrder[a] - keysInOrder[b]).forEach(key => sortedSecondaryFieldItemMap[key] = secondaryFieldItemMap[key])
        return  Object.values(sortedSecondaryFieldItemMap).join("::")
      }).filter(item => item !== "")

      return {
        primaryData: primaryFieldData,
        additionalFieldData: secondaryFieldData
      }
    },
    convertToVersionTwo: (field1String, field2SetOfString) => {
      let result = []

      let jsonNode1 = {}
      field1String.split("::").forEach((item, index) => jsonNode1[keysInOrder[index]] = item)
      result.push(JSON.stringify(jsonNode1))

      if (field2SetOfString !== undefined && field2SetOfString !== null  && field2SetOfString.length > 0) {
        field2SetOfString.forEach(item => {
          let jsonNode2 = {}
          item.split("::").forEach((element, index) => jsonNode2[keysInOrder[index]] = element)

          result.push(JSON.stringify(jsonNode2))
        })
      }

      return result
    }
  }
}


// WEBPACK FOOTER //
// ./node_modules/@abc/transformers/src/transformers/lineItem/json/index.js